// The Rails CSRF token, for requests a controller sends with `fetch` rather than a form.
export default function csrfToken() {
  return document.querySelector('meta[name="csrf-token"]')?.content || '';
}
